export const MONTHLY_PRICE = 9.99;

export const PRICES = {
  '3': 29.99,
  '6': 49.99,
  '12': 95.99,
} as const;

export const STARS_AMOUNT = {
  '3': 1499,
  '6': 2499,
  '12': 4750,
} as const;

export type Period = keyof typeof PRICES;

export const calculateSavings = (period: Period): number => {
  const originalPrice = +(MONTHLY_PRICE * parseInt(period)).toFixed(2);
  const currentPrice = PRICES[period];
  return +(originalPrice - currentPrice).toFixed(2);
};

